import { useEffect } from 'react';

/**
 * @param {string} src 链接
 */
export function useScript(src) {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = src;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
}
